module.exports = __webpack_public_path__ + "static/media/bg-construcao.3a534feb.png";